import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const LinkedInIcon = ({ color = '#292D32', size = 22, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.025 0H10.975C4.91366 0 0 4.91365 0 10.975V11.025C0 17.0863 4.91366 22 10.975 22H11.025C17.0863 22 22 17.0863 22 11.025V10.975C22 4.91365 17.0863 0 11.025 0Z" fill="#007EBB" />
    <path d="M5.2463 7.31304C4.95658 7.04405 4.8125 6.71107 4.8125 6.3149C4.8125 5.91873 4.95735 5.57111 5.2463 5.30134C5.53603 5.03234 5.90897 4.89746 6.3659 4.89746C6.82283 4.89746 7.18114 5.03234 7.47009 5.30134C7.75981 5.57034 7.9039 5.90871 7.9039 6.3149C7.9039 6.72109 7.75904 7.04405 7.47009 7.31304C7.18037 7.58204 6.81281 7.71693 6.3659 7.71693C5.91899 7.71693 5.53603 7.58204 5.2463 7.31304ZM7.66041 8.85612V17.1033H5.05521V8.85612H7.66041Z" fill="#FEFFFC" />
    <path d="M16.3366 9.67101C16.9047 10.2876 17.1883 11.1339 17.1883 12.2115V16.9578H14.7134V12.546C14.7134 12.0026 14.5724 11.5802 14.291 11.2796C14.0097 10.979 13.6305 10.8279 13.1557 10.8279C12.6809 10.8279 12.3017 10.9782 12.0203 11.2796C11.739 11.5802 11.598 12.0026 11.598 12.546V16.9578H9.1084V8.83319H11.598V9.91072C11.85 9.55155 12.1899 9.2679 12.6169 9.05902C13.0439 8.85015 13.5241 8.74609 14.0583 8.74609C15.0094 8.74609 15.7693 9.0544 16.3366 9.67101Z" fill="#FEFFFC" />
  </svg>

);

export default LinkedInIcon;